import { IHWSSquadKeys, IProperty } from '../../consumerUxlApis/types/property.types';
import { BRAND_CODES } from '../../constants';

export const getHWSSquadAttributes = (property: IProperty | undefined, propertyId: string): IHWSSquadKeys => {
  const basicInfo = property?.basicInformation;
  const contactInfo = property?.contactInformation;
  const propertyAttributes: IHWSSquadKeys = {
    prop_address_city: '',
    prop_address_city_state_country: '',
    prop_address_country_abbr: '',
    prop_address_state_abbr: '',
    prop_address_state_name: '',
    prop_brand_code: '',
    prop_brand_name: '',
    prop_brand_tier: '',
    prop_currency_type: '',
    prop_is_ers: '',
    prop_marsha_code: '',
    prop_name: '',
    prop_earn_rewards: '',
    prop_rewards_category_level: '',
    prop_rewards_earn_points_participant: '',
    prop_address_lat_long: '',
    mrshaCode: '',
    hotelLoc: '',
    brndCode: '',
  };
  propertyAttributes['mrshaCode'] = propertyId;
  propertyAttributes['prop_marsha_code'] = propertyId?.toUpperCase();
  if (basicInfo) {
    propertyAttributes['prop_name'] = basicInfo?.name;

    let propBrandCode = basicInfo?.brand?.id;
    if (propBrandCode) {
      propBrandCode = propBrandCode.toUpperCase();
      let propBrandTierValue = null;
      switch (true) {
        case BRAND_CODES.LUXURY.includes(propBrandCode):
          propBrandTierValue = 'Luxury';
          break;
        case BRAND_CODES.PREMIUM.includes(propBrandCode):
          propBrandTierValue = 'Premium';
          break;
        case BRAND_CODES.SELECT.includes(propBrandCode):
          propBrandTierValue = 'Select';
          break;
        case BRAND_CODES.LONGER_STAYS.includes(propBrandCode):
          propBrandTierValue = 'Longer Stays';
          break;
        default:
          propBrandTierValue = null;
      }
      if (propBrandTierValue) {
        propertyAttributes['prop_brand_tier'] = propBrandTierValue;
      }
    }
    propertyAttributes['prop_brand_code'] = basicInfo?.brand?.id;
    propertyAttributes['brndCode'] = basicInfo?.brand?.id;
    propertyAttributes['prop_is_ers'] = basicInfo?.isMarshaProperty ? 'false' : 'true';
    propertyAttributes['prop_brand_name'] = basicInfo?.brand?.name;
    propertyAttributes['prop_currency_type'] = basicInfo?.currency;
    propertyAttributes['prop_rewards_earn_points_participant'] = String(basicInfo?.participateRewards);
    propertyAttributes['prop_earn_rewards'] = String(basicInfo?.participateRewards);
    propertyAttributes['prop_address_lat_long'] = `${basicInfo?.latitude || 0},${basicInfo.longitude || 0}`;
  }

  if (contactInfo) {
    const hotelAddressCity = contactInfo?.address?.city;
    let hotelAddressState = contactInfo?.address?.stateProvince?.code;
    const hotelAddressCountry = contactInfo?.address?.country?.code;
    propertyAttributes['prop_address_city'] = hotelAddressCity;
    if (!hotelAddressState || hotelAddressState.toLowerCase() === 'null') {
      hotelAddressState = '';
    }
    propertyAttributes[
      'prop_address_city_state_country'
    ] = `${hotelAddressCity}|${hotelAddressState}|${hotelAddressCountry}`;

    const propAddressStateName = contactInfo?.address?.stateProvince?.description;

    if (propAddressStateName) {
      propertyAttributes['prop_address_state_name'] = propAddressStateName;
    }

    if (hotelAddressState) {
      propertyAttributes['prop_address_state_abbr'] = hotelAddressState;
    }

    propertyAttributes['hotelLoc'] = `${hotelAddressCity},${hotelAddressState},${hotelAddressCountry}`;
    propertyAttributes['prop_address_country_abbr'] = hotelAddressCountry;
    propertyAttributes['prop_rewards_category_level'] = String(basicInfo?.category);
  }
  // removing empty and undefined keys
  const filteredObj = Object.fromEntries(
    Object.entries(propertyAttributes).filter(([_, value]) => value != null && value !== '')
  );

  return filteredObj;
};
